import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/fonts.css'
import './assets/css/style.css'
Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)


new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js